import React from 'react';
const fmt = require("indian-number-format"); // Assuming this is installed and working

export default function HeaderAccount({
  booked,
  commission,
  rent,
  commissionShow,
  isDollar,
}) {
  // Determine currency symbol once
  const currency = isDollar === 1 ? "$" : "";
  
  // Helper to safely format number and apply Indian format
  const formatValue = (value) => {
    // Ensure value is treated as a number, fix to 2 decimal places, then apply custom formatting
    const num = parseFloat(value);
    if (isNaN(num)) return `0.00 ${currency}`;

    // Apply currency formatting
    return `${fmt.format(num.toFixed(2))} ${currency}`;
  };

  return (
    <div className="px-5 py-3 text-[14px] space-y-1 text-[var(--text)] ">
      {/* 1. Booked P&L */}
      <div className="flex justify-between">
        <span>Booked :</span>
        <span
          className={`font-semibold ${
            booked > 0 ? "text-[var(--buymeta)]" : "text-[var(--sellmeta)]"
          } `}
        >
          {formatValue(booked)}
        </span>
      </div>

      {/* 2. Commission (Conditionally Shown) */}
      {/* Note: commissionShow is checked against 1, which implies it's a number/string from the backend */}
      {commissionShow == 1 && ( 
        <div className="flex justify-between">
          <span>Commission :</span>
          {/* Commissions are typically costs, so they are often styled as negative/red */}
          <span className={`font-semibold text-[var(--sellmeta)]`}>
            {formatValue(commission)}
          </span>
        </div>
      )}

      {/* 3. Interest/Rent (Conditionally Shown if greater than 0) */}
      {rent > 0 && (
        <div className="flex justify-between">
          <span>Interest :</span>
          {/* Interest is also typically a cost */}
          <span className={`font-semibold text-[var(--sellmeta)]`}>
            {formatValue(rent)}
          </span>
        </div>
      )}
    </div>
  );
}